import styled from "@emotion/styled";
import {
  APP_BREAKPOINT,
  APP_CONTENT_WIDTH_APPOINTMENT
} from "src/constants/layout";
import CollectionTitle from "../../../StyledComponents/CollectionTitle";

export const AppointmentContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const EventContent = styled.div`
  ol {
    padding-left: 1.5rem;
  }

  a {
    color: var(--color-sunrise-blue);
  }
`;

export const GradientWrap = styled.div`
  position: relative;
  width: 100%;
  height: 8.5rem;
  overflow: visible;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: ${APP_BREAKPOINT}px) {
    height: 6.5rem;
  }
`;

export const GradientForm = styled.div`
  position: absolute;
  width: 160%;
  height: 70vh;
  bottom: 0;
  background: linear-gradient(65deg, #80aeff 0%, #f7bde6 52%, #ffbd70 100%);
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 50%;

  @media screen and (max-width: ${APP_BREAKPOINT}px) {
    width: 260%;
  }
`;

export const DefaultAvatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: -1.875rem;
  height: 6.5rem;
  width: 6.5rem;
  border-radius: 50%;
  background-color: var(--color-cream);
  object-fit: contain;
  border: 0.25rem solid var(--color-gray-light);
`;

export const Picture = styled.img`
  object-fit: cover;
  position: absolute;
  bottom: -1.875rem;
  height: 6.5rem;
  width: 6.5rem;
  border-radius: 50%;
  background-color: var(--color-cream);
  border: 0.25rem solid var(--color-gray-light);
`;

export const HostAvatarWrap = styled.div`
  position: absolute;
  bottom: -1.875rem;

  > div {
    width: 6.5rem;
    height: 6.5rem;
    min-width: 6.5rem;
    border: 0.25rem solid var(--color-gray-light);

    .avatar-border {
      display: none;
    }
  }
`;

export const Wrap = styled.div`
  max-width: ${APP_CONTENT_WIDTH_APPOINTMENT / 16}rem;
  margin-top: 3rem;
  padding-bottom: 2rem;

  @media screen and (max-width: ${APP_BREAKPOINT}px) {
    padding: 0 1.5rem 2rem;
  }

  h1 {
    text-wrap: balance;
  }
`;

export const ActionsWrap = styled.div`
  margin-top: 1.5rem;
  border-top: 0.125rem solid var(--color-cream-dark);
  border-bottom: 0.125rem solid var(--color-cream-dark);
  padding: 1.5rem 0;
  display: grid;
  gap: 1.5rem;
  grid-auto-rows: 1fr;
  grid-template-columns: repeat(1, 1fr);

  :has(.appointment-action:nth-of-type(2)) {
    grid-template-columns: repeat(2, 1fr);
  }

  :has(.appointment-action:nth-of-type(3)) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const ActionContainer = styled.div`
  background-color: var(--color-white);
  border-radius: 50%;
  height: 3rem;
  width: 3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: var(--light-shadow);

  &:hover {
    box-shadow: var(--large-shadow);
  }

  svg {
    height: 1.5rem;
    width: 1.5rem;
  }
`;

export const Action = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 0.75rem;
  text-align: center;
  font-size: 0.875rem;
  font-weight: 500;
  span {
    display: block;
    max-width: 6rem;
  }
`;

export const EventTitle = styled.h1`
  text-align: center;
`;

export const EventDateTime = styled.h2`
  margin-top: 1.5rem;
  text-align: center;
`;

export const JoiningInstructions = styled.p`
  margin: 0.5rem 0 0;
  text-align: center;
`;

export const EventContentTitle = styled(CollectionTitle)`
  margin-top: 1.5rem;
`;

export const LabsHintWrap = styled.div`
  margin-top: 1.5rem;
  padding: 1.25rem 1.5rem;
  border-radius: 1rem;
  border-left: 0.25rem solid var(--Accessible-PurpleHaze, #5f1f8f);
  background-color: rgba(95, 31, 143, 0.12);
  text-align: left;

  h3 {
    font-size: 1rem;
    font-weight: 500;
    color: var(--Accessible-PurpleHaze, #5f1f8f);
    margin: 0 0 0.5rem;
  }

  p {
    font-size: 0.9375rem;
    line-height: 1.5;
    margin: 0;
  }
`;

export const LabsHintCta = styled.button`
  margin-top: 0.75rem;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--Accessible-PurpleHaze, #5f1f8f);

  svg {
    width: 1rem;
    height: 1rem;
  }

  path {
    fill: currentColor;
  }
`;
